<template>
    <div class="f1 ly-note--operation__body">
        <!-- 文本操作部分 start -->
        <div class="ly-note--list" ref="list" :style="{width: currWidth}">   
            <!-- 间隔层 start -->
            <el-row :style="{width: listWidth}">
                <el-col :span="colSpan" :style="{width: colWidth}" class="ly-note--oper">
                    <div class="ly-note--edge"></div>
                    <note-editor :is-mirror="isMirror" v-model="splitArr[0]"></note-editor>
                </el-col>
                <el-col :span="colSpan" :style="{width: colWidth}" v-for="(el, i) in splitArr" v-if="i > 0" :key="i">
                    <note-mirror v-model="splitArr[i]"></note-mirror>
                </el-col>
            </el-row>
        </div>
        <!-- 文本操作部分 end -->
    </div>
</template>
<script>
    import NoteEditor from './editor'
    import NoteMirror from './mirror'
    /**
     * 编辑内容的容器面板
     */
    export default {
        props: {
            arr: Array, // 拆分文字后的数据
            isMirror: {
                type: Boolean,
                default: true
            } // 标识是否开启镜像操作
        },
        components: {
            NoteEditor,
            NoteMirror
        },
        data () {
            return {
                splitArr: [],
                currWidth:'100%', // 容器的宽度 
                listWidth: '100%', // 编辑列表部分的宽度
                minWidth: 340, // 最小列宽
                colWidth: '340px'
            }
        },
        watch: {
            splitArr (arr) {
                this.$emit('input', arr)
            }
        },
        computed: {
            /**
             * 计算span的值
             */
            colSpan () {
                let span = 24
                if (this.splitArr.length > 0) {
                    span = parseInt(span / this.splitArr.length)
                    if (span === 12) {
                        this.colWidth = '50%'
                    } else {
                        this.colWidth = '340px'
                    }
                }
                return span
            }
        },
        created () {
            this.splitArr = this.arr
        },
        mounted () {
            // 获取当前列的宽度
            let currWidth = this.$refs.list.offsetWidth
            this.currWidth = currWidth + 'px'
            // 呈现的宽度
            let showWidth = this.minWidth * this.splitArr.length
            this.listWidth = (showWidth > currWidth ? showWidth : currWidth) + 'px'
        }
    }
</script>
<style>
    .ly-note--operation__body {
        position: relative;
    }
    .ly-note--list {
        height: 100%;
        overflow-x: scroll;
    }
    .ly-note--operation .el-row,
    .ly-note--operation .el-col {
        height: 100%;
        overflow: hidden;
    }
    /* .ly-note--list .el-row {
        min-height: 450px;
    } */
</style>
